import mainApiClient from '../interceptor.mainApiClient';

const caseSummaryEndpoints = {
  getDashboardOverview: (data, config) =>
    mainApiClient.post('/api/v1/AIChat/dashboard-overview', data, config),
  getAnalysis: (data, config) =>
    mainApiClient.post('/api/v1/case-summary/analysis', data, config),
  getByPeopleId: (peopleId, config) =>
    mainApiClient.get(`/api/v1/case-summary/${peopleId}`, config),
};

export default caseSummaryEndpoints;
